export const entityRoutes = [
    {
        path: '/:tenantId/entity/:entityType/capabilities',
        name: 'entity.capabilities.index',
        component: () => import('@/pages/admin/entity-module/Features.vue')
    },
    {
        path: '/:tenantId/entity/:entityType/capabilities/:featureId',
        name: 'entity.features.edit',
        component: () => import('@/pages/admin/entity-module/FeatureEdit.vue')
    },

    {
        path: '/:tenantId/entity/:entityType/views',
        name: 'entity.views.index',
        component: () => import('@/pages/admin/entity-view/Index.vue')
    },
    {
        path: '/:tenantId/entity/:entityType/views/:key',
        name: 'entity.views.edit',
        component: () => import('@/pages/admin/entity-view/Edit.vue')
    },

    // Route generiche per tutte le entità
    {
        path: '/:tenantId/entity/:entityType',
        name: 'entity.index',
        component: () => import('@/pages/admin/entity/Index.vue')
    },
    {
        path: '/:tenantId/entity/:entityType/create',
        name: 'entity.create',
        component: () => import('@/pages/admin/entity/Create.vue')
    },
    {
        path: '/:tenantId/entity/:entityType/:id/edit',
        name: 'entity.edit',
        component: () => import('@/pages/admin/entity/Edit.vue')
    },

    // Attributi delle entità
    {
        path: '/:tenantId/entity/:entityType/attributes',
        name: 'entity.attributes.index',
        component: () => import('@/pages/admin/entity-attribute/Index.vue')
    },
    {
        path: '/:tenantId/entity/:entityType/attributes/create',
        name: 'entity.attributes.create',
        component: () => import('@/pages/admin/entity-attribute/Create.vue')
    },
    {
        path: '/:tenantId/entity/:entityType/attributes/:id/edit',
        name: 'entity.attributes.edit',
        component: () => import('@/pages/admin/entity-attribute/Edit.vue')
    }
]

export const appEntityRoutes = entityRoutes.map(route => ({
    ...route,
    path: route.path.replace('/entity/:entityType', '/apps/:installationKey/:moduleKey'),
    name: `app.${route.name}`,
    meta: { ...route.meta, appEntity: true },
}))

export const appEntityNotFoundRoute = {
    path: '/:tenantId/apps/:appModulePath(.*)*',
    name: 'app-module-not-found',
    component: () => import('@/pages/NotFound.vue'),
}
